import { WorkspaceSubscriptionAccountTrustEventRecord } from '../../../../../../../../server-services/query-records/workspace-records';
import { WorkspaceChangeSubscriptionSpecificHandler } from '../types';

export let onModifyDialogueTypingEventSubscriptionHandler: WorkspaceChangeSubscriptionSpecificHandler =
  (cache, event: WorkspaceSubscriptionAccountTrustEventRecord) => {};
